import React, { useEffect, useState } from "react";
import { Route, useHistory } from "react-router-dom";
import { useSelector } from "react-redux";

const PrivateRoute = ({ path, routeAccess, component: Component, ...restOfProps }) => {
  const { user } = useSelector((state) => state.auth);
  const history = useHistory();
  const { subscriptionData } = useSelector((state) => state.subscription);

  const isTrialExpired =
    subscriptionData?.subscription?.currentPlan?.plan === "Trial" &&
    subscriptionData?.subscription?.currentPlan?.status === "Expired" &&
    subscriptionData?.subscription?.userTrial?.isTrialExpired === true;

  const isSubscriptionPaused =
    subscriptionData?.subscription?.currentPlan?.status === "Paused" || subscriptionData?.subscription?.currentPlan?.status === "Suspended";

  const [shouldRender, setShouldRender] = useState(false);

  useEffect(() => {
    if (routeAccess) {
      localStorage.setItem("prevLocation", path);
    }
  }, [restOfProps, path, routeAccess]);

  // let companyInfoRoute = "/user-or-company";
  let companyInfoRoute = "/analytics/sales-summary";
  let prevLocation = localStorage.getItem("prevLocation");
  let companyInfo = user?.companyId?.profession || user?.companyId?.industry || user?.companyId?.companyName;

  useEffect(() => {
    if (isTrialExpired || isSubscriptionPaused) {
      history.push("/subscription");
    }
  }, [isTrialExpired, history, isSubscriptionPaused]);

  useEffect(() => {
    if (routeAccess && companyInfo) {
      setShouldRender(true);
    } else if (routeAccess && !companyInfo) {
      history.replace(companyInfoRoute);
    }
    // else if (!routeAccess && companyInfo && prevLocation && prevLocation !== path) {
    //   history.replace(prevLocation);
    // }
    else {
      history.replace("/");
    }
    //eslint-disable-next-line
  }, [routeAccess, companyInfo, prevLocation, path, history, restOfProps]);

  return shouldRender ? <Route path={path} component={Component} {...restOfProps} /> : null;
  // return (
  //   <Route
  //     render={(props) =>
  //       companyInfo && routeAccess ? (
  //         <Component {...props} />
  //       ) : routeAccess && !companyInfo ? (
  //         <Redirect to={companyInfoRoute} />
  //       ) : companyInfo && !routeAccess ? (
  //         <Redirect to={currLocation} />
  //       ) : (
  //         <Redirect to={"/error"} />
  //       )
  //     }
  //   />
  // );
};
export default PrivateRoute;
